import React from 'react';
import { Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Import all sections
import NavigationBar from '../components/demo/NavigationBar';
import HeroSection from '../components/demo/HeroSection';
import DemoVideoSection from '../components/demo/DemoVideoSection';
import AudienceStrip from '../components/demo/AudienceStrip';
import PainPointsGrid from '../components/demo/PainPointsGrid';
import ContactSection from '../components/demo/ContactSection';
import Footer from '../components/demo/Footer';
import StickyDemoForm from '../components/demo/StickyDemoForm';

const LandingPage = () => {
  const theme = useTheme();


  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: theme.palette.background.default,
      }}
    >
      {/* Navigation Bar */}
      <NavigationBar />
      
      {/* Spacer for fixed navbar */}
      <Box sx={{ height: '64px' }} />
      
      {/* Hero + Form Split Layout */}
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            alignItems: 'flex-start',
          }}
        >
          {/* Left Side - Hero + Demo Video */}
          <Box
            sx={{
              flex: { md: '1 1 60%' },
              width: { xs: '100%', md: 'auto' },
              order: { xs: 2, md: 1 },
            }}
          >
            <HeroSection />
            
            {/* Demo Video Section */}
            <Box sx={{ mt: 2 }}>
              <DemoVideoSection />
            </Box>
          </Box>
          
          {/* Right Side - Sticky Demo Form */}
          <Box
            sx={{
              flex: { md: '0 0 400px' },
              width: { xs: '100%', md: '400px' },
              order: { xs: 1, md: 2 },
              position: { md: 'sticky' },
              top: { md: '80px' },
            }}
          >
            <StickyDemoForm />
          </Box>
        </Box>
      </Container>
      
      {/* Audience Strip */}
      <AudienceStrip />
      
      {/* Pain Points Grid */}
      <PainPointsGrid />
      
      {/* Contact Section */}
      <ContactSection />
      
      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default LandingPage;
